import { type formatOrder, type PayoutOrder } from '~/entities/payout';

type OrderFormatter = Pick<typeof formatOrder, 'currency' | 'date' | 'status'>;

export const getOrderCopyText = (order: PayoutOrder, formatter: OrderFormatter) => {
    const requisite = order.requisiteV2?.card?.number || order.requisiteV2?.sbp?.phoneNumber;

    return `${order.id?.value}, ${order.amount?.value}${formatter.currency(order.currency)}, ${formatter.date(order.createdAt)}, ${requisite}, ${order.status ? formatter.status(order.status) : 'Неизвестно'}`;
};
